import { downgradeComponent } from '@angular/upgrade/static';
import { ActionFeedbackComponent } from '../ng2/hospital-booking/action-feedback/action-feedback.component';
import { ExecuteActionComponent } from '../ng2/hospital-booking/execute-action/execute-action.component';

const hospitalBooking = angular.module('hospitalBooking', ['main']);

const autoload = require.context('.', true, /\.(html|json|woff|woff2|ttf|eot|svg|gif|png|jpg)$/);
const object = autoload.keys();
object.forEach((name) => {
  autoload(name);
});

hospitalBooking
  .config(require('./config/routes.js'))
  .directive('actionFeedback', downgradeComponent({
    component: ActionFeedbackComponent,
    inputs: [],
    outputs: [],
  }))
  .directive('executeAction', downgradeComponent({
    component: ExecuteActionComponent,
    inputs: [],
    outputs: [],
  }))
  .run(['$translate', '$translatePartialLoader', ($translate, $translatePartialLoader) => {
    $translatePartialLoader.addPart('hospital-booking');
    return $translate.refresh();
  },
  ]);

module.exports = hospitalBooking;



// WEBPACK FOOTER //
// ./hospital-booking/hospital-booking.js